import { memo } from 'react'
import { Outlet } from 'react-router-dom'
import { Header } from '../organisms/Header'
import { Footer } from '../organisms/Footer'
import { MobileNav } from '../organisms/MobileNav'
import { SearchOverlay } from '../organisms/SearchOverlay'

/**
 * MainLayout — structural wrapper for all public-facing routes.
 *
 * Renders:
 *   ├── Header (sticky, mega nav)
 *   ├── MobileNav (slide-in drawer)
 *   ├── SearchOverlay (mobile search modal)
 *   ├── <main> with Outlet
 *   └── Footer
 *
 * Background: Royal Ivory (#FAFAF7)
 * No gradients. No decorative shadows on layout chrome.
 */
export const MainLayout = memo(function MainLayout() {
  return (
    <div className="min-h-screen bg-royal-ivory flex flex-col font-sans antialiased">
      <Header />
      <MobileNav />
      <SearchOverlay />

      <main
        id="main-content"
        tabIndex={-1}
        className="flex-1 focus-visible:outline-none"
        aria-label="Main content"
      >
        <Outlet />
      </main>

      <Footer />
    </div>
  )
})